import styled, { css } from 'styled-components'

import { NAVBAR_HEIGHT_PX } from 'assets/styles/layout'

export const NavbarWrapper = styled.div<{
    isNavbarWhite?: boolean
}>`
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1050;
    margin-bottom: 20px;
    box-sizing: border-box;
    user-select: none;

    @media print {
        display: none !important;
        box-shadow: none !important;
        border: none !important;
    }

    ${({ isNavbarWhite, theme }) => css`
        box-shadow: ${theme.elevations.large};
        background-color: ${isNavbarWhite
            ? theme.colors.monochrome.white
            : theme.colors.brand.primary};
    `}
`

export const NavbarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-height: ${NAVBAR_HEIGHT_PX}px;
    padding: 12px 50px;
`

export const NavbarContainerLogo = styled.div`
    flex-shrink: 0;
`

export const NavbarLink = styled.a`
    text-decoration: none;
`

export const NavbarLogo = styled.img`
    max-height: 55px;
`

export const NavbarNav = styled.ul`
    display: flex;
    align-items: center;
    max-height: ${NAVBAR_HEIGHT_PX}px;
`
